export default "__VITE_ASSET__BoAZ4Sps__"